import { FC, useState } from 'react';
import styled, { css } from 'styled-components';

import { useInterwillStore } from '@/entities/interwills';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

import { useIwUiStore } from '../../stores/useIwUi';

import { tabs } from './index';

import { InterwillInfoPanelStyledComponents } from './styles';

const { AnimatedWrapper, ContentContainer, NavContainer, Title } =
  InterwillInfoPanelStyledComponents;

export const InterwillInfoPanelDesktop: FC = () => {
  const iwStore = useInterwillStore();
  const iwUiStore = useIwUiStore();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  // By default sidebard should be closed on 3,4 steps
  const defaultSidebarOpened = ![3, 4, 5].includes(iwStore.progressStep);
  const isOpen = iwUiStore.sidebarOpened ?? defaultSidebarOpened;

  return (
    <Container $isOpen={isOpen} className="infopanel">
      <LeftPanel>
        <NavContainer>
          {tabs.map((item, idx) => {
            const isSelected = activeTabIndex === idx;
            return (
              <Icon
                key={idx}
                name={item.iconName}
                size="s20"
                style={{
                  cursor: 'pointer',
                  color: isSelected ? COLORS.blueColor : COLORS.grey,
                }}
                onClick={() => setActiveTabIndex(idx)}
              />
            );
          })}
        </NavContainer>

        <Icon
          name="caret-right"
          size="s20"
          onClick={() => iwUiStore.toggleSidebar(!isOpen)}
          style={{ cursor: 'pointer' }}
        />
      </LeftPanel>

      <AnimatedWrapper $isOpen={isOpen}>
        <ContentContainer>
          <Title>{tabs[activeTabIndex].title}</Title>
          {tabs[activeTabIndex].content}
        </ContentContainer>
      </AnimatedWrapper>
    </Container>
  );
};

const Container = styled.div<{ $isOpen: boolean }>`
  display: flex;

  width: ${({ $isOpen }) =>
    $isOpen
      ? css`var(--iw-sidebar-desktop-width-expanded)`
      : css`var(--iw-sidebar-desktop-width-folded)`};

  transition: width var(--ani-speed) ease-in-out;

  border-radius: 12px;
  background-color: ${COLORS.white};
  container-type: inline-size;
`;

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px;
`;
